<template>
  <v-theme-provider root>
    <v-layout fill-height column>
      <v-app-bar dense>
        <v-app-bar-nav-icon @click.stop="$emit('drawer')"></v-app-bar-nav-icon>
        <v-toolbar-title v-text="'<ecucode/> '+hash"></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on='on' small text @click.stop="toggleDarkMode()">
              <v-icon>fas fa-adjust</v-icon>
            </v-btn>
          </template>
          <span>Light/Dark Mode</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on='on' small text color="#F92672" href="https://microbit-micropython.readthedocs.io/en/latest/microbit_micropython_api.html" target="_blank">
              <v-icon>fas fa-book</v-icon>
            </v-btn>
          </template>
          <span>MicroPython Reference</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn-toggle :value="options.blockly.shown?[1]:[0]" multiple>
              <v-btn v-on='on' small text @click.stop="toggleBlockly()">
                <v-icon>fab fa-python</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
          <span>Toggle Blockly</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn-toggle :value="options.vterm.shown?[0]:[1]" multiple>
              <v-btn :disabled="!webusb.connected" v-on='on' small text @click.stop="togglevterm()">
                <v-icon small>fas fa-terminal</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
          <span>REPL</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn :color="options.blockly.shown?'#AE81FF':'#66D9EF'" v-on='on' small text @click='fileSave'>
              <v-icon>fas fa-file-download</v-icon>
            </v-btn>
          </template>
          <span v-if="options.blockly.shown">Download Blockly (.xml)</span>
          <span v-else>Download Python (.py)</span>
        </v-tooltip>

        <v-tooltip bottom v-if="options.blockly.shown">
          <template v-slot:activator="{ on }">
            <v-btn color="#AE81FF" v-on='on' small text @click='$refs.file_input.click()'>
              <v-icon>fas fa-file-upload</v-icon>
              <input type="file" style="display: none" ref="file_input" accept="text/xml" multiple=false @change="fileLoad">
            </v-btn>
          </template>
          <span>Upload Blockly (.xml)</span>
        </v-tooltip>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <v-btn color="#66D9EF" v-on='on' small text @click='$refs.file_input_py.click()'>
              <v-icon>fas fa-file-upload</v-icon>
              <input type="file" style="display: none" ref="file_input_py" accept=".py" multiple=false @change="fileLoad">
            </v-btn>
          </template>
          <span>Upload Python (.py)</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="#A6E22E" v-on='on' small text @click='config.zoom+=1'>
              <v-icon>fas fa-search-plus</v-icon>
            </v-btn>
          </template>
          <span>Zoom In</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="#A6E22E" v-on='on' small text @click='config.zoom-=1'>
              <v-icon>fas fa-search-minus</v-icon>
            </v-btn>
          </template>
          <span>Zoom Out</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="#FD971F" v-on='on' small text :class="{'v-btn--active': options.dialogs.firmware.shown}" @click.stop="options.dialogs.firmware.shown = !options.dialogs.firmware.shown">
              <v-icon>fas fa-microchip</v-icon>
            </v-btn>
          </template>
          <span>Update Micro:Bit</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="#FD971F" v-on='on' small text @click.stop="blockly_setup.shown = !blockly_setup.shown">
              <v-icon>fas fa-puzzle-piece</v-icon>
            </v-btn>
          </template>
          <span>Tweak Blockly Toolbox</span>
        </v-tooltip>
      </v-app-bar>

      <v-layout fill-height ref="content" column>
        <v-layout>
          <blockly-editor 
            ref='blockly' 
            :zoom = "config.zoom" 
            :toolbox_xml = "blockly_setup.toolbox_xml" 
            @changed = "onBlocklyChanged" 
            @loaded = "onBlocklyLoaded"
            v-show = "options.blockly.shown" 
            :style = "{
              'max-height': options.vterm.shown ? config.dividers.horizontal.top + 'px' : config.content.height  + 'px', 
              'max-width': options.blockly.shown ? config.dividers.vertical.left + 'px' : config.content.width + 'px'
            }" 
            @prompt = "prompt"
          ></blockly-editor>
          <div 
            class="divider-vertical" 
            :style="{
              'width': config.dividers.vertical.thickness + 'px !important'
            }" 
            @mousedown="onVDividerDown()" 
            v-show="options.blockly.shown"></div>
          <v-flex>
            <ace-editor 
              ref = "ace" 
              :zoom = "config.zoom" 
              :style = "{
                'max-height' : options.vterm.shown ? config.dividers.horizontal.top + 'px' : config.content.height + 'px'
              }" 
              lang = "python" 
              theme = "monokai" 
              @changed = "onAceChanged"
              @loaded = "onAceLoaded"
              :disabled = "options.blockly.shown"
            ></ace-editor>
          </v-flex>
        </v-layout>
        <div 
          class = "divider-horizontal" 
          :style = "{
            'height' : config.dividers.horizontal.thickness + 'px !important'
          }" 
          @mousedown = "onHDividerDown()" 
          v-if = "options.vterm.shown"
        ></div>
        <vterm 
          ref = "vterm" 
          :style = "{
            'max-height' : config.content.height - config.dividers.horizontal.thickness - config.dividers.horizontal.top + 'px'
          }" 
          @vterm-data = "onVtermData" 
          v-show = "options.vterm.shown"
        ></vterm>
        <v-progress-linear color="#FD971F" :value="webusb.upload_progress" class="progress" v-show="webusb.busy"></v-progress-linear>
      </v-layout>

      <v-dialog v-model="options.dialogs.plotter.shown" @click.outside="options.dialogs.plotter.shown=!options.dialogs.plotter.shown">
        <v-card>
          <plotter title="Micro:Bit Plotter"></plotter>
        </v-card>
      </v-dialog>

      <v-dialog v-model="options.dialogs.firmware.shown" width="700" :persistent='Boolean(webusb.firmware_progress)'>
        <v-stepper non-linear alt-labels v-model="options.dialogs.firmware.s">

          <v-stepper-header>
            <v-stepper-step :complete="options.dialogs.firmware.s > 1" step="1">Firmware</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2">MicroPython</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>

            <v-stepper-content step="1">
              <v-card>
                <v-card-text>
                  <v-layout>
                    <v-flex>
                      In order to use a Micro:Bit device with this website requires the device is flashed with the most recent 'Maintenance' file. 
                      <ol>
                        <li>Disconnect the Micro:Bit device from the computer.</li>
                        <li>Press and hold the reset button on the back of the Micro:Bit device.</li>
                        <li>Don't let go yet... Connect the Micro:Bit. Don't let go still...</li>
                        <li>The Micro:Bit should mount with the name "MAINTENANCE". You can let go now...</li>
                        <li>Download the "Maintenance.hex" file from the link below.</li>
                        <li>Drag and drop the "Maintenance.hex" file to the Micro:Bit "MAINTENCE" device</li>
                        <li>The device will now process the file, disconnect itself, and remount as "MICROBIT"</li>
                      </ol>
                      <br>Next you MUST flash MicroPython to the Micro:Bit!<br>Click "MICROPYTHON" below...
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="#FD971F" outlined @click="fileSaveFirmware()"><v-icon left>fas fa-file-download</v-icon>MAINTENANCE.hex</v-btn>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn small fab v-on='on' color="#FD971F" text href="https://github.com/ARMmbed/DAPLink" target="_blank">
                        <v-icon>fab fa-github-alt</v-icon>
                      </v-btn>
                    </template>
                    <span>DAPLink Github</span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on='on' color="#FD971F" text href="https://microbit.org/get-started/user-guide/firmware/#checking-your-firmware-version" target="_blank">
                        <v-icon>fas fa-book</v-icon>
                      </v-btn>
                    </template>
                    <span>Micro:Bit Maintenance Infomation</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card>
                <v-card-text>
                  <v-layout>
                    <v-flex>
                      After applying the "Maintenance.hex" firmware (or at any time after applying the firmware) you need to flash a fresh copy of the MicroPython runtime.
                      <ol>
                        <li>Click the button "Flash uPy" below.</li>
                        <li>From the dialog that appears, select the device titled "BBC micro:bit CMSIS-DAP".</li>
                        <li>Click connect from the same dialog.</li>
                        <li>Wait for the device to flash (you should see a progress bar).</li>
                        <li>Don't disconnect the device from the computer, otherwise you might have to start over...</li>
                        <li>Once complete, the progress bar will disappear and this dialog can be closed.</li>
                      </ol>
                      You're good to go now!
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="#FD971F" :loading='upy.busy' :disabled='webusb.firmware_progress>0' outlined @click="UPyFlash()">
                    <v-icon left>fab fa-python</v-icon>
                    Flash MicroPython
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
              <v-progress-linear bottom color="#FD971F" v-if='webusb.firmware_progress>0' :value='webusb.firmware_progress'></v-progress-linear>
            </v-stepper-content>

            <v-layout>
              <v-btn color="#A6E22E" outlined v-if='options.dialogs.firmware.s>1' @click="options.dialogs.firmware.s-=1">
                <v-icon left>fas fa-arrow-left</v-icon>
                Firmware
              </v-btn>
              <v-btn color="#A6E22E" outlined v-if='options.dialogs.firmware.s<2' @click="options.dialogs.firmware.s+=1">
                <v-icon left>fas fa-arrow-right</v-icon>
                MicroPython
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn text outlined color="#F8F8F0" @click="options.dialogs.firmware.shown = false" :disabled='webusb.firmware_progress>0'>
                <v-icon left>fas fa-times</v-icon>
                Close
              </v-btn>
            </v-layout>

          </v-stepper-items>
        </v-stepper>
      </v-dialog>

      <v-snackbar v-model="options.snackbar.shown" top vertical :timeout='options.snackbar.timeout' :color='options.snackbar.color'>
        {{ options.snackbar.text }}
        <v-btn dark text @click="options.snackbar.shown=false">Close</v-btn>
      </v-snackbar>

      <v-speed-dial absolute bottom right direction="left" open-on-hover transition="slide-y-reverse-transition">
          <template v-slot:activator>
            <v-btn slot="activator" large fab :loading="webusb.busy"
            @click="connect()" 
            :color="webusb.connected?(webusb.busy?'#FD971F':'#A6E22E'):'#F92672'"
            :active="!webusb.busy">
              <svg v-cloak class="svg svg-icon-touchdevelop" viewBox="50 50 380 380" xmlns="http://www.w3.org/2000/svg" role="presentation" aria-label="touchdevelop,white" style="width: 42px" v-if="webusb.connected">
                <path d="m 185.96612,110.36806 41.029,41.029 0,-72.834699 27.352,0 0.001,72.834699 41.029,-41.029 0,31.911 -54.706,54.706 -54.705,-54.706 0,-31.911 z m 98.203,181.9 c 0,-9.128 7.406,-16.539 16.541,-16.539 9.146,0 16.535,7.411 16.535,16.539 0,9.131 -7.389,16.548 -16.535,16.548 -9.135,0 -16.541,-7.417 -16.541,-16.548 z m -121.494,0.003 c 0,-9.129 7.413,-16.542 16.548,-16.542 9.129,0 16.537,7.413 16.537,16.542 0,9.131 -7.408,16.547 -16.537,16.547 -9.135,0 -16.548,-7.416 -16.548,-16.547 z m 16.544,-81.93 122.554,0.202 c 45.667,0 82.285,36.553 82.285,81.732 0,45.179 -36.757,81.934 -81.937,81.934 l -122.902,0 c -45.177,0 -81.934395,-36.755 -81.934395,-81.934 0,-45.179 36.757395,-81.934 81.934395,-81.934 z m -49.164,81.934 c 0,27.105 22.059,49.164 49.164,49.164 l 122.902,0 c 27.107,0 49.159,-22.059 49.159,-49.164 0,-27.112 -22.052,-49.164 -49.159,-49.164 l -122.902,0 c -27.105,0 -49.164,22.052 -49.164,49.164 z" id="path3341" inkscape:connector-curvature="0" style="fill:#FFF"></path>
              </svg>
              <v-icon v-else>fab fa-usb</v-icon>
            </v-btn>
          </template>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on='on' v-if="webusb.connected" fab small color="#F92672" @click="disconnect()">
                <v-icon small>fas fa-plug</v-icon>
              </v-btn>
            </template>
            <span>Disconnect Micro:Bit</span>
          </v-tooltip>
        </v-speed-dial>
    </v-layout>
  </v-theme-provider>
</template>

<script>
import Runtime from 'raw-loader!../assets/micropython.hex'
import Maintenance from 'raw-loader!../assets/maintenance.hex'

import AceEditor from '../components/AceEditor.vue'
import BlocklyEditor from '../components/BlocklyEditor.vue'
import Vterm from '../components/Vterm.vue'

import JSONBlocks from '../assets/blocks.json'
import ToolboxConfig_All from '../assets/toolbox_configs/all.json'
import ToolboxConfig_Default from '../assets/toolbox_configs/default.json'
import ToolboxConfig_Test_1 from '../assets/toolbox_configs/test.1.json'
import XMLBuilder from 'xmlbuilder'
import { toXML } from 'jstoxml'
var FileSaver = require('file-saver');

import uPy from '../assets/js/upy.js'
const DAPjs = require('dapjs');
//let xmlbuilder = require('xmlbuilder');

function jsonCopy(src) {
  return JSON.parse(JSON.stringify(src));
}

export default {
  components: {
    AceEditor,
    BlocklyEditor,
    Vterm
  },
  props: ['hash'],
  data () {
    return {
      blockly_setup: {
        shown: true,
        enabled: true,
        blocks: JSONBlocks,
        configs: {
          default: ToolboxConfig_Default,
          all: ToolboxConfig_All,
          test: [
            ToolboxConfig_Test_1
          ]
        },
        toolbox_xml:""
      },
      title: '/',
      config: {
        dividers: {
          vertical: {
            is_down: false,
            left: 400,
            thickness: 7
          },
          horizontal: {
            is_down: false,
            thickness: 7,
            top: 600
          },
        },
        mouse: {
          x: 700,
          y: 700
        },
        zoom: 0,
        content: {
          bottom: 978,
          height: 930,
          left: 0,
          right: 1307,
          top: 48,
          width: 1307,
          x: 0,
          y: 48
        }
      },
      options: {
        dialogs: {
          plotter: {
            shown: false
          },
          firmware: {
            shown: false,
            s: 1
          },
        },
        toggle: [0],
        blockly: {
          shown: true
        },
        python: false,
        vterm: {
          shown: true,
          modes: {
            paste: false,
            raw: false
          }
        },
        snackbar: {
          shown: false,
          text: '',
          timeout: 10000,
          color: ''
        }
      },
      webusb: {
        upload: 0,
        serial_number: "",
        connected: false,
        firmware_progress: 0,
        busy: false
      },
      daplink: Object,
      files: {
        maintenance: { name: 'maintenance.hex', data: Maintenance },
        runtime: { name: 'micropython.hex', data: Runtime }
      },
      upy: Object,
      main_window: {
        width: Number,
        height: Number,
        toolbar_height: Number
      },
      log: {
        user: {
          keys: ''
        }
      }
    }
  },
  watch: {
    hash: function(hash) {
      processURLHash(hash);
    }
  },
  methods: {
    prompt(message, color) {
      if (this.options.snackbar.shown) this.options.snackbar.shown = false;
      this.options.snackbar.color = color;
      this.options.snackbar.text = message;
      this.options.snackbar.shown = true;
    },
    async onVtermData(data) {
      this.upy.send(data);
    },
    async connect() {
      let that = this;
      this.webusb.busy = true;
      if (this.webusb.connected) {
        try {
          await this.upy.test()
        } catch (e) {
          this.prompt(`Micropython was unresponsive or doesn't exist. Reflash Micropython`, 'red');
          this.options.dialogs.firmware.shown = true;
          this.options.dialogs.firmware.s = 2;
          this.disconnect();
          this.webusb.busy = false;
          return
        }
        try {
          await this.upy.upload(this.$refs.ace.getPython(), this.webusb.device)
        } catch (e) {
          this.prompt(e.message, 'red');
        }
      } else {
        try {
          this.disconnect();
          await this.request();
          await this.webusb.daplink.connect();
          await this.webusb.daplink.setSerialBaudrate(115200);
        } catch (e) {
          if (e.message.toString().match(/.*No valid interfaces found.*/gm)) {
            this.prompt(`Micro:Bit is not up to date. Flash the MAINTENANCE.hex file to the Micro:Bit to update it.`, 'red') //<-- toast  
            this.options.dialogs.firmware.shown = true;
            this.options.dialogs.firmware.s = 1;
          } else if (e.message.toString().match(/.*Bad response/gm))
            this.prompt(`Bad response from Micro:Bit. Unplug and reconnect the Micro:Bit.`, 'error');
          else
            this.prompt(`${e.message}`, 'error');
          return
        }
        this.webusb.serial_number = this.webusb.daplink.transport.device.serialNumber;
        delete this.upy;
        this.$refs.vterm.clear();
        this.upy = new uPy(this.webusb.daplink);
        this.upy.on('upy-upload-progress', function(progress) {
          that.webusb.upload_progress = progress;
        });
        this.upy.on('upy-rx', function(rx) { 
          try {
            that.$refs.vterm.write(rx); 
          } catch (e) {}
        });
        this.upy.on('prompt', function(msg, color) {
          that.prompt(msg, color);
        })
        try {
          await this.upy.test()
        } catch (e) {
          this.prompt(`Micropython was unresponsive or doesn't exist. Reflash Micropython`, 'red');
          this.options.dialogs.firmware.shown = true;
          this.options.dialogs.firmware.s = 2;
          this.disconnect();
          this.webusb.busy = false;
          return
        }
        this.webusb.connected = true;
        this.togglevterm(true);
        this.prompt(`MicroPython connected.`, 'green');
      }
      this.webusb.busy = false;
    },
    async request() {
      try {
        // possible to find more devices than just the microbit using this command
        // navigator.usb.requestDevice({filters:[]}).then( function(device) { console.log(device); });
        // ESP32S:
        //  productName: "CP2102 USB to UART Bridge Controller"
        //  vendorId: 4292 or 0x10C4
        let device = await navigator.usb.requestDevice({ filters: [{vendorId: 0xD28}] })
        this.webusb.daplink = new DAPjs.DAPLink(new DAPjs.WebUSB(device));
        return true
      } catch (e) {
        this.prompt(`Failed to acquire Micro:Bit. [${e}]`, 'red') //<-- toast
      }
      return false
    },
    disconnect() {
      console.log('disconnecting...');
      this.webusb.connected = false;
      try {
        this.upy.disconnect();
      } catch(e) {};
      try {
        this.webusb.daplink.disconnect()
      } catch(e) {};
      if (this.options.vterm.shown) 
        this.togglevterm();
      delete this.webusb.daplink;
      this.webusb.busy = false;
      console.log('disconnected...');
    },
    async UPyFlash() {
      const that = this;
      let flashf = function(progress) {
        that.webusb.firmware_progress = progress*100;
        console.log('Daplink.EVENT_PROGRESS', that.webusb.firmware_progress);
      }
      if (this.options.vterm.shown) this.togglevterm();
      await this.disconnect();
      if (await this.request()) {
        try {
          await this.webusb.daplink.connect();
          let img = (new TextEncoder()).encode(this.files.runtime.data).buffer;
          this.webusb.daplink.on(DAPjs.DAPLink.EVENT_PROGRESS, flashf);
          await this.webusb.daplink.flash(img);
          this.prompt('MicroPython flashing complete!', 'success');
        } catch(e) {
          if (e.toString().match(/.*Bad response/gm)) {
            this.prompt(`Bad response from Micro:Bit. Unplug and reconnect the Micro:Bit.`, 'error');
          } else if (e.toString().match(/.*Flash error/gm)) {
            this.prompt(`Could not initiate flash. Unplug and reconnect the Micro:Bit and try again, or reflash the MAINTENANCE file.`, 'error');
            this.options.dialogs.firmware.shown = true;
            this.options.dialogs.firmware.s = 2;
          } else
            this.prompt(`${e}`, 'error');
        }
      }
      this.webusb.firmware_progress = 0;
      try { 
        this.webusb.daplink.off(DAPjs.DAPLink.EVENT_PROGRESS, flashf);
      } catch (err) {}
      this.disconnect();
    },
    processURLHash(hash) {
      console.log(hash);
      switch (hash) {
      case "test.1":
        this.loadBlocklyConfig(this.blockly_setup.configs.test[0]);
        break;
      case "noblockly":
        this.toggleBlockly();
        break;
      case "all":
        this.loadBlocklyConfig(this.blockly_setup.configs.all);
        break;
      default:
        this.loadBlocklyConfig(this.blockly_setup.configs.default);
      }
    },
    loadBlocklyConfig(config) {
      for (let ci = 0; ci < config.xml.category.length; ci++) {
        let blocks = []
        if ('block' in config.xml.category[ci]) {
          for (let bi = 0; bi < config.xml.category[ci].block.length; bi++) {
            config.xml.category[ci].block[bi] = this.blockly_setup.blocks[config.xml.category[ci].block[bi]];
          }
        } else if ('category' in config.xml.category[ci]) {
          for (let cj = 0; cj < config.xml.category[ci].category.length; cj++) {
            if ('block' in config.xml.category[ci].category[cj]) {
              for (let bi = 0; bi < config.xml.category[ci].category[cj].block.length; bi++) {
                config.xml.category[ci].category[cj].block[bi] = this.blockly_setup.blocks[config.xml.category[ci].category[cj].block[bi]];
              }
            }
          }
        }
      }
      this.blockly_setup.toolbox_xml = "";
      this.blockly_setup.toolbox_xml = XMLBuilder.create(config, { encoding: 'utf-8' }).root().toString();
    },
    onBlocklyChanged(blockly) {
      let python = this.$refs.blockly.getPython();
      if (this.options.blockly.shown) {
        localStorage.code_blockly = blockly;
        localStorage.code_python = python;
        localStorage.last_save = Date.now();
      }
      this.$refs.ace.load(python);
    },
    onAceChanged(python) {
      if (!this.options.blockly.shown) {
        localStorage.code_python = python; 
        localStorage.last_save = Date.now();
      }
    },
    onBlocklyLoaded() {
      if (typeof(localStorage.code_blockly) !== 'undefined') {
        if (localStorage.last_save && (Date.now() - localStorage.last_save) / 1000 < 60*5) {
          console.log('onBlocklyLoaded', localStorage.last_save, (Date.now() - localStorage.last_save) / 1000);
          this.$refs.blockly.load(localStorage.code_blockly, false);
        }
      }
    },
    onAceLoaded() {
      if (typeof(localStorage.code_python) !== 'undefined') {
        if (localStorage.last_save && (Date.now() - localStorage.last_save) / 1000 < 60*5) {
          console.log('onAceLoaded', localStorage.last_save, (Date.now() - localStorage.last_save) / 1000);
          this.$refs.ace.load(localStorage.code_python);
        }
      }
    },
    fileSaveFirmware() {
      FileSaver.saveAs(new Blob([this.files.maintenance.data], {type: "text/plain;charset=utf-8"}), 'maintenance.hex');
    },
    fileSave() {
      let blob, name;
      if (this.options.blockly.shown) {
        blob = new Blob([localStorage.code_blockly], {type:"text/plain;charset=utf-8"});
        name = 'microbit.xml'
      } else {
        blob = new Blob([localStorage.code_python], {type:"text/plain;charset=utf-8"});
        name = 'microbit.py'
      }
      FileSaver.saveAs(blob,name);
    },
    fileLoad(e) {
      console.log(e.target.files)
      if (e.target.files != undefined && e.target.files.length > 0) {
        if (e.target.files[0].type == "text/xml") {
          let reader = new FileReader();
          let _t = this;
          reader.onload = () => {
            _t.$refs.blockly.load(reader.result);
            _t.$refs.file_input.value = "";
          };
          reader.readAsText(e.target.files[0]);
        } else if (e.target.files[0].type == "text/x-python-script") {
          let reader = new FileReader();
          let _t = this;
          reader.onload = () => {
            _t.$refs.ace.load(reader.result);
            _t.$refs.file_input_py.value = "";
          };
          reader.readAsText(e.target.files[0]);
        } else {
          console.log('fileLoad', e.target.files[0].type, '?')
        }
      }
    },
    fileSaveBlockly() {
      this.$refs.blockly.save('blockly.xml');
    },
    onVDividerDown(e) {
      this.config.dividers.vertical.prev = this.config.dividers.vertical.left;
      this.config.dividers.vertical.is_down = true;
      this.config.dividers.horizontal.is_down = false;
      window.addEventListener('mousemove', this.onMouseMove, false);
    },
    onHDividerDown(e) {
      this.config.dividers.horizontal.prev = this.config.dividers.horizontal.top;
      this.config.dividers.horizontal.is_down = true;
      this.config.dividers.vertical.is_down = false;
      window.addEventListener('mousemove', this.onMouseMove, false);
    },
    onMouseMove(e) {
      if (!e) var e = window.event;
      this.config.mouse.x = e.pageX;
      this.config.mouse.y = e.pageY;
      if (this.config.dividers.vertical.is_down) {
        let l = this.config.mouse.x-(this.config.dividers.vertical.thickness/2);
        if (l < 350) l = 350;
        if (l > this.config.content.width - 400) l = this.config.content.width - 400;
        let _t = this; window.requestAnimationFrame(() => {
          _t.config.dividers.vertical.left = l;
        });
        this.onResize();
      } else if (this.config.dividers.horizontal.is_down) {
        let l = this.config.mouse.y-this.config.content.top;
        if (l > this.config.content.height-this.config.content.top-150)
          l = this.config.content.height-this.config.content.top-150;
        let _t = this; window.requestAnimationFrame(function() {
          _t.config.dividers.horizontal.top = l;
        });
        this.onResize();
      }
      return false;
    },
    toggleBlockly() {
      this.options.blockly.shown = !this.options.blockly.shown;
      this.onResize();
    },
    togglevterm(b) {
      if (b === undefined) this.options.vterm.shown = !this.options.vterm.shown;
      else this.options.vterm.shown = b;
      this.onResize();
    },
    toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.$refs.blockly.toggleDarkMode(this.$vuetify.theme.dark);
      this.$refs.ace.toggleDarkMode(this.$vuetify.theme.dark);
      this.$refs.vterm.toggleDarkMode(this.$vuetify.theme.dark);
    },
    onResize() {
      let that = this;
      window.requestAnimationFrame(function() {
        if (that.$refs.content != undefined) {
          that.config.content = that.$refs.content.getBoundingClientRect();
          that.$refs.blockly.resize();
          that.$refs.ace.resize();
          that.$refs.vterm.resize();
        }
      })
    },
    onKeystroke(e) {
      console.log(e);
      this.log.user.keys+=e.key;
    }
  },
  mounted () {
    let that = this;
    window.addEventListener('resize', this.throttled(66, this.onResize));
    window.addEventListener('mouseup', () => {
      this.config.dividers.horizontal.is_down = false;
      this.config.dividers.vertical.is_down = false;
      window.removeEventListener('mousemove', this.onMouseMove, false)
    }, false)
    this.onResize();
    this.config.dividers.horizontal.top = this.config.content.height*.75;
    this.config.dividers.vertical.left = this.config.content.width*.45;
    let _t = this;
    window.requestAnimationFrame(function() {
      _t.togglevterm(false);
    });
    this.$root.$emit('vue-loaded');
    this.processURLHash(this.hash);
  }
}
</script>

<style scoped>
.grid {
  transition: all 1s ease-in-out;
}
.progress {
  margin: 0px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 100;
}
.grid-blockly {
}
.grid-ace {
}
.grid-console {
}
.divider-vertical {
  background-color: #E6DB74;
  cursor: col-resize;
  height: 100%;
}
.divider-horizontal {
  background-color: #E6DB74;
  cursor: row-resize;
  width: 100%;
}
.upload {
  position: fixed;
  right: 8px;
  bottom: 8px;
}
</style>